// extracted by mini-css-extract-plugin
export default {"title-bar":"TrailerModal_title-bar__Euj1G","title":"TrailerModal_title__JdBAn","close-button":"TrailerModal_close-button__xqSPT","player":"TrailerModal_player__o88zb"};